import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import TextualContent from '../../TextualContent';
import { useDeviationViewContext } from '../../../Context';
import { FullViewProps } from '../types';
import AutoSizedText from '../_partials/AutoSizedText';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getDeviationTitle } from '../../_helpers';

import s from './Tier.scss';

const TierFullView: React.FC<FullViewProps> = ({
  deviation,
  width,
  height,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const { isFullscreen, isTheater } = useDeviationViewContext();
  const { unlockPolicy } = (deviation.tier || {});
  const style =
    isTheater || isFullscreen || isMobile ? { width, height } : { width };

  return (
    <div
      className={classnames(s['root'], isFullscreen && s['fullscreen'])}
      style={style}
    >
      <div className={s['content-wrap']}>
        <div className={s['title-wrap']}>
          <AutoSizedText
            className={s['title']}
            tooBigClassName={s['better-fit']}
            maxHeight={180}
          >
            {getDeviationTitle(deviation)}
          </AutoSizedText>
          {(
            unlockPolicy === 'onetime_payment' ||
            unlockPolicy === 'watch'
          ) && (
            <span className={s['subtitle']}>
              {t(`deviationview.tier.unlockPolicy.${unlockPolicy}`)}
            </span>
          )}
        </div>

        {isFullscreen && (
          <TextualContent deviation={deviation} withArtist={false} />
        )}
      </div>
    </div>
  );
};
TierFullView.displayName = 'TierFullView';
export default TierFullView;
